import React, {useCallback} from 'react';

import {UPLOAD_USERS_LIST_TEMPLATE} from 'src/constants';
import {UsersGroupsHeader} from 'src/modules/profile/account/tabs/users-and-groups/users-groups-header';

import Button, {FlatButton} from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

type Props = {
    disabled: boolean,
    onCLear?: () => void,
};

export const Header = ({disabled, onCLear}: Props) => {
    const downloadTemplate = useCallback(() => {
        window.open(UPLOAD_USERS_LIST_TEMPLATE);
    }, []);

    return (
        <UsersGroupsHeader activeTab="upload-list">
            <Group justify="space-between">
                <Typography
                    fontWeight="semi-bold"
                    variant="heading-level-3">
                    Upload List
                </Typography>
                <Group alignItems="center">
                    <FlatButton onClick={downloadTemplate}>Download the template</FlatButton>
                    <Button variant="Type.SECONDARY" disabled={disabled} onClick={onCLear}>Clear List</Button>
                </Group>
            </Group>
        </UsersGroupsHeader>
    );
};
